(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/nova/tab-link.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/nova/tab-link.js');
'use strict';

const TabLink = _ref => {
  let isActive = _ref.isActive,
    onClick = _ref.onClick,
    children = _ref.children;
  return React.createElement("button", {
    "aria-current": isActive ? 'page' : undefined,
    className: "qa-ticket-tab-link ticket-tab-link u-flex u-flex-align-items-center u-flex-justify-content-center pointer ".concat(isActive ? 'ticket-tab-link--active' : 'ticket-tab-link--muted'),
    disabled: isActive,
    onClick: onClick,
    type: "button"
  }, React.createElement("span", {
    className: "ticket-tab-link__label u-block w100 u-overflow-threedots u-text-center"
  }, children));
};
setGlobal('svs.tickets.next.components.nova.TabLink', TabLink);

 })(window);